import { connect } from 'react-redux'
import { withMe } from 'pobble-components/dist/pobble-user'
import User from './user'

const mapStateToProps = (state, { me }) => ({
  name:
    me &&
    me.account &&
    (me.account.student_type ? me.account.display_name : me.account.full_name)
})

export default withMe(
  connect(
    mapStateToProps,
    null
  )(User)
)
